import { noddiAsync, URLKeys } from 'noddi-async';
import { SALES_ITEM_BOOKING_FLOW_TYPE } from 'noddi-types';
import { groupCars } from 'noddi-util';
import { useBookingAddress, useBookingSelectedSalesItemsCars, useLocalizationLanguage } from 'noddi-web';

export const useGetUnavailableSalesItems = () => {
  const selectedSalesItemsCars = useBookingSelectedSalesItemsCars();
  const language = useLocalizationLanguage();

  // Incompatibles are only relevant for primary sales items for now
  const filteredSalesItemsCars = selectedSalesItemsCars.filter(
    (car) => car.type === SALES_ITEM_BOOKING_FLOW_TYPE.PRIMARY
  );

  const selectedAddress = useBookingAddress();

  const {
    data: unavailableSalesItems,
    isLoading: isUnavailableSalesItemsLoading,
    error: unavailableSalesItemsError
  } = noddiAsync.usePostAsGetQuery({
    type: URLKeys.getUnavailableSalesItemsWithPost,
    input: {
      addressId: selectedAddress?.id as number,
      cars: groupCars(filteredSalesItemsCars),
      language
    },
    queryConfig: {
      staleTime: Infinity,
      enabled: !!selectedAddress && !!filteredSalesItemsCars.length
    }
  });

  return {
    unavailableSalesItems: unavailableSalesItems?.data ?? [],
    isUnavailableSalesItemsLoading,
    unavailableSalesItemsError
  };
};
